// extracted by mini-css-extract-plugin
module.exports = {"container":"Parallax_container___9lQS","logos":"Parallax_logos___IiRr","heading":"Parallax_heading__8J5xT","subline":"Parallax_subline__EZ08B"};